const shape = {
  borderRadius: 12,
};

export default shape;
